// @flow
import * as React from 'react';
import type { RouterHistory } from 'react-router-dom';
import type { Authentication } from '../../types';
import LoginPageDisplay from './LoginPageDisplay';
import withAuthentication from '../withAuthentication';

class LoginPage extends React.Component<
  {
    authentication: Authentication,
    history: RouterHistory
  },
  {
    errors: Array<string>,
    userName: string,
    password: string
  }
> {
  state = {
    errors: [],
    userName: '',
    password: ''
  };

  handleChange = (event: SyntheticKeyboardEvent<HTMLInputElement>): void => {
    const { name, value } = event.currentTarget;
    this.setState({ [name]: value });
  };

  handleForgottenPassword = () => {
    this.props.history.push('forgottenPassword');
  };

  handleSubmit = (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const { userName, password } = this.state;
    const errors = [];

    if (userName.length === 0) {
      errors.push('Please enter a user name');
    }

    if (password.length === 0) {
      errors.push('Please enter a password');
    }

    if (errors.length > 0) {
      this.setState({ errors });
      return;
    }

    this.props.authentication
      .login(userName, password)
      .then((verify: boolean) =>
        this.props.history.replace({
          pathname: verify ? '/verify' : '/'
        })
      )
      .catch(errors => this.setState({ errors, password: '' }));
  };

  render() {
    const { userName, password, errors } = this.state;

    return (
      <LoginPageDisplay
        userName={userName}
        password={password}
        errors={errors}
        onChange={this.handleChange}
        onClickForgottenPassword={this.handleForgottenPassword}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default withAuthentication(LoginPage);
